// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__1W72L","timezone":"styles_timezone__2bgII","amount":"styles_amount__2O_Co","members":"styles_members__21WSR","members-width":"styles_members-width__1FkGU"};